import { HomeCityIcon } from './HomeCityIcon';

/**
 * author: Google
 * id 4D49A420-B80E-48FA-A331-A556002EA46F
 * name home-city
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-city.svg
 * tags
 * - Home Automation 
 */
export const HouseCityIcon = HomeCityIcon;
export default HouseCityIcon